export enum WorkflowType {
   Daily = 0,
   NonDaily = 1,
   Private = 2,
   Contracts = 3,
   Form = 4
}
